import { defineComponent as y, computed as v, ref as N, provide as P, h as t } from "vue";
import L from "./ghl-ui.es1338.js";
import { itemRenderer as M } from "./ghl-ui.es1009.js";
import { useMenuChild as F } from "./ghl-ui.es1339.js";
import { useMenuChildProps as O } from "./ghl-ui.es1340.js";
import { submenuInjectionKey as k, menuItemGroupInjectionKey as A } from "./ghl-ui.es1011.js";
import E from "./ghl-ui.es690.js";
import j from "./ghl-ui.es310.js";
import D from "./ghl-ui.es830.js";
const K = Object.assign(Object.assign({}, O), {
  rawNodes: {
    type: Array,
    default: () => []
  },
  tmNodes: {
    type: Array,
    default: () => []
  },
  tmNode: {
    type: Object,
    required: !0
  },
  disabled: Boolean,
  icon: Function,
  onClick: Function,
  domId: String,
  virtualChildActive: {
    type: Boolean,
    default: void 0
  },
  isEllipsisPlaceholder: Boolean
}), J = y({
  name: "Submenu",
  props: K,
  setup(i) {
    const n = F(i), {
      NMenu: o,
      NSubmenu: s
    } = n, {
      props: d,
      mergedCollapsedRef: l,
      mergedThemeRef: u
    } = o, r = v(() => {
      const {
        disabled: e
      } = i;
      return s != null && s.mergedDisabledRef.value || d.disabled ? !0 : e;
    }), a = N(!1);
    P(k, {
      paddingLeftRef: n.paddingLeft,
      mergedDisabledRef: r
    }), P(A, null);
    function c() {
      const {
        onClick: e
      } = i;
      e && e();
    }
    function h() {
      r.value || (l.value || o.toggleExpand(i.internalKey), c());
    }
    function p(e) {
      a.value = e;
    }
    return {
      menuProps: d,
      mergedTheme: u,
      doSelect: o.doSelect,
      inverted: o.invertedRef,
      isHorizontal: o.isHorizontalRef,
      mergedClsPrefix: o.mergedClsPrefixRef,
      maxIconSize: n.maxIconSize,
      activeIconSize: n.activeIconSize,
      iconMarginRight: n.iconMarginRight,
      dropdownPlacement: n.dropdownPlacement,
      dropdownShow: a,
      paddingLeft: n.paddingLeft,
      mergedDisabled: r,
      mergedValue: o.mergedValueRef,
      childActive: E(() => {
        var e;
        return (e = i.virtualChildActive) !== null && e !== void 0 ? e : o.activePathRef.value.includes(i.internalKey);
      }),
      collapsed: v(() => d.mode === "horizontal" ? !1 : l.value ? !0 : !o.mergedExpandedKeysRef.value.includes(i.internalKey)),
      dropdownEnabled: v(() => !r.value && (d.mode === "horizontal" || l.value)),
      handlePopoverShowChange: p,
      handleClick: h
    };
  },
  render() {
    var i;
    const {
      mergedClsPrefix: n,
      menuProps: {
        renderIcon: o,
        renderLabel: s
      }
    } = this, d = () => {
      const {
        isHorizontal: u,
        paddingLeft: r,
        collapsed: a,
        mergedDisabled: c,
        maxIconSize: h,
        activeIconSize: p,
        title: e,
        childActive: S,
        icon: w,
        handleClick: C,
        menuProps: {
          nodeProps: f
        },
        dropdownShow: x,
        iconMarginRight: I,
        tmNode: g,
        mergedClsPrefix: b,
        isEllipsisPlaceholder: z,
        extra: R
      } = this, m = f == null ? void 0 : f(g.rawNode);
      return t("div", Object.assign({}, m, {
        class: [`${b}-menu-item`, m == null ? void 0 : m.class],
        role: "menuitem"
      }), t(L, {
        tmNode: g,
        paddingLeft: r,
        collapsed: a,
        disabled: c,
        iconMarginRight: I,
        maxIconSize: h,
        activeIconSize: p,
        title: e,
        extra: R,
        showArrow: !u,
        childActive: S,
        clsPrefix: b,
        icon: w,
        hover: x,
        onClick: C,
        isEllipsisPlaceholder: z
      }));
    }, l = () => t(D, null, {
      default: () => {
        const {
          tmNodes: u,
          collapsed: r
        } = this;
        return r ? null : t("div", {
          class: `${n}-submenu-children`,
          role: "menu"
        }, u.map((a) => M(a, this.menuProps)));
      }
    });
    return this.root ? t(j, Object.assign({
      size: "large",
      trigger: "hover"
    }, (i = this.menuProps) === null || i === void 0 ? void 0 : i.dropdownProps, {
      themeOverrides: this.mergedTheme.peerOverrides.Dropdown,
      theme: this.mergedTheme.peers.Dropdown,
      builtinThemeOverrides: {
        fontSizeLarge: "14px",
        optionIconSizeLarge: "18px"
      },
      value: this.mergedValue,
      disabled: !this.dropdownEnabled,
      placement: this.dropdownPlacement,
      keyField: this.menuProps.keyField,
      labelField: this.menuProps.labelField,
      childrenField: this.menuProps.childrenField,
      onUpdateShow: this.handlePopoverShowChange,
      options: this.rawNodes,
      onSelect: this.doSelect,
      inverted: this.inverted,
      renderIcon: o,
      renderLabel: s
    }), {
      default: () => t("div", {
        class: `${n}-submenu`,
        role: "menuitem",
        "aria-expanded": !this.collapsed,
        id: this.domId
      }, d(), this.isHorizontal ? null : l())
    }) : t("div", {
      class: `${n}-submenu`,
      role: "menuitem",
      "aria-expanded": !this.collapsed,
      id: this.domId
    }, d(), l());
  }
});
export {
  J as NSubmenu,
  K as submenuProps
};
